import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Header,
  Textarea,
  Container,
  SpaceBetween,
  Box,
  Grid,
  Link,
  ExpandableSection,
  FileUpload,
  Modal,
  Spinner,
  Checkbox,
  ColumnLayout,
  Select,
  Tabs,
  Input,
  TokenGroup,
  Table
} from "@amzn/awsui-components-react";
import { v4 as uuidv4 } from 'uuid';
import './styles.scss'
const TANCFilterManager = (props) => {
  var [filters, setFilters] = useState(props.getValues() || []);
  var [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    loadRows()
    return () => {
    };
  }, []);

  useEffect(() => {
    loadRows()
  }, [props?.reloadNotifiers])

  useEffect(() => {
    if (isInValid()) {
      let msg = ''
      if (props?.errorMessage) {
        msg = props?.errorMessage
      }
      setErrorMessage(msg)
    } else {
      setErrorMessage('')
      props.updateValue(getMergedInputValues())
    }
  }, [filters])


  const getMergedInputValues = () => {
    var filtered = filters?.filter(function (row) {
      return row != null;
    });
    if (filtered?.hasOwnProperty('information')) {
      filtered['information'] = JSON.stringify(filtered['information'])
    }
    if (filtered?.hasOwnProperty('extras')) {
      filtered['extras'] = JSON.stringify(filtered['extras'])
    }
    return filtered
  }

  const isInValid = () => {
    return props.validator && !props.validator(getMergedInputValues())
  }

  const onEdit = (value, index, key) => {
    filters[index][key] = value
    filters[index][props.lastUpdatedTimeKey] = null
    setFilters([...filters])
  }

  const onEditFilterConfig = (filterIndex, value, index, key) => {
    filters[filterIndex]['information'][index][key] = value
    filters[filterIndex]['information'][index][props.lastUpdatedTimeKey] = null
    setFilters([...filters])
  }

  const onEditExtras = (filterIndex, value, key) => {
    if (!filters[filterIndex].hasOwnProperty('extras')) {
      filters[filterIndex]['extras'] = {}
    }else if(filters[filterIndex].hasOwnProperty('extras') && filters[filterIndex]['extras'] == null){
       filters[filterIndex]['extras'] = {}
    }
    filters[filterIndex]['extras'][key] = value
    setFilters([...filters])
  }

  const getFilterItem = (value, index) => {
    return <SpaceBetween direction="vertical" size="m" key={index}>
      <ExpandableSection
        variant="container"
        headerText={value.hasOwnProperty(props.filterNameKey) ? value[props.filterNameKey] : ''}
        headerActions={
          <>{
            getFilterActionButtons(index)
          }</>
        }
      >
        <SpaceBetween direction="horizontal" size="m">
          <Box variant="h4">Filter name</Box>
          <Input
            onChange={({ detail }) => {
              let val = detail.value
              if (props?.postProcess) {
                val = props.postProcess(detail.value)
              }
              onEdit(val, index, props.filterNameKey)
            }}
            placeholder={props.filterNamePlaceholder}
            value={value.hasOwnProperty(props.filterNameKey) ? value[props.filterNameKey] : ''}
          />
          {
            value['to_delete'] ? <Box variant="small"><span className='red_badge'>Marked to delete</span></Box> : <></>
          }
        </SpaceBetween>

        <SpaceBetween>
          <Checkbox
            onChange={({ detail }) =>
              onEditExtras(index, detail.checked, 'allEdit')
            }
            checked={value?.extras?.['allEdit'] || false}
          >
            All Editable
          </Checkbox>
        </SpaceBetween>

        <SpaceBetween size="m">
          <Table
            columnDefinitions={[
              {
                id: "column_name",
                header: "Columns",
                cell: item => item.column_name,
                sortingField: "name",
                isRowHeader: true
              },
              {
                id: "values",
                header: "Values",
                cell: item => item.values
              },
              {
                id: "can_edit",
                header: "Can edit",
                cell: item => item.can_edit,
                sortingField: "alt"
              },
              {
                id: "delete",
                header: "Actions",
                cell: item => item.delete,
                minWidth: 170
              }
            ]}
            columnDisplay={[
              { id: "column_name", visible: true },
              { id: "values", visible: true },
              { id: "can_edit", visible: true },
              { id: "delete", visible: true }
            ]}
            enableKeyboardNavigation
            items={getInputItemForTable(value, index)}
            loadingText="Loading resources"
          />

          {/* {props?.filterConfigsKey && value && value.hasOwnProperty(props.filterConfigsKey) && value[props.filterConfigsKey] ? (Array.from(value[props.filterConfigsKey]).map((config, configIndex) => {
              return getInputItem(value, index, config, configIndex);
            })) : ''} */}

        </SpaceBetween>
      </ExpandableSection>

    </SpaceBetween>
  }

  const getInputItem = (filter, filterIndex, value, index) => {
    return <div className='rows' key={`${filterIndex}_${index}`}>
      <Container >
        <SpaceBetween direction="vertical">
          <Box float="right">
            <div className="row"><Button iconName="close" variant="icon" onClick={() => {
              deleteRow(filterIndex, index)
            }} />

            </div>
          </Box>
          <SpaceBetween key={index} direction="horizontal" size="s">
            <SpaceBetween direction="vertical">
              <Box variant="h4">Column name</Box>
              <Select
                selectedOption={value.hasOwnProperty(props.columnNameKey) ? { 'label': value[props.columnNameKey], 'value': value[props.columnNameKey] } : null}
                onChange={({ detail }) =>
                  onEditFilterConfig(filterIndex, detail.selectedOption.value, index, props.columnNameKey)
                }
                options={props.getColumns()}
                placeholder={props?.selectHint ? props.selectHint : "Choose options"}
              />
            </SpaceBetween>

            <SpaceBetween direction="vertical">
              <div className="param_input">
                <Box variant="h4">values</Box>
                <Input
                  onChange={({ detail }) => {
                    let val = detail.value
                    onEditFilterConfig(filterIndex, { label: val.trim(), dismissLabel: val.trim() }, index, 'typed_value')

                  }}
                  onKeyDown={({ detail }) => {
                    if (detail.key == 'Enter') {
                      if (value['typed_value'] == undefined || value['typed_value']?.label == undefined || value['typed_value']?.label == '') {

                      } else {
                        if (!value.hasOwnProperty('field_tokens')) {
                          value['field_tokens'] = []
                        }
                        value['field_tokens'].push(value['typed_value'])
                        // resetting the typed value for new values. Existing value is already added to token list
                        onEditFilterConfig(filterIndex, undefined, index, 'typed_value')
                      }
                    }
                  }}
                  placeholder="values"
                  value={value?.typed_value?.label}
                  disabled={value?.field_type == 'input' ? true : (value.limit && value['field_tokens']?.length >= value.limit ? true : false)}
                />
                {
                  value?.typed_value?.label ? <span className="hintMessage">Press Enter for the values to be considered</span> : ''
                }
              </div>
              <TokenGroup
                onDismiss={({ detail: { itemIndex } }) => {
                  let arr = value?.field_tokens
                  arr.splice(itemIndex, 1)
                  onEditFilterConfig(filterIndex, arr, index, 'field_tokens')
                }}
                items={value?.field_tokens}
              />
            </SpaceBetween>

            <SpaceBetween direction="vertical">
              <Box variant="h4">Can edit</Box>
              <Checkbox
                onChange={({ detail }) =>
                  onEditFilterConfig(filterIndex, detail.checked, index, props.radioKey)
                }
                checked={value.hasOwnProperty(props.radioKey) ? value[props.radioKey] : false}
                disabled={filter?.['extras']?.['allEdit'] || false}
              >
              </Checkbox>
            </SpaceBetween>

          </SpaceBetween>
        </SpaceBetween>
      </Container>
    </div>
  }

  const getInputItemForTable = (filter, filterIndex) => {
    let items = []
    Array.from(filter[props.filterConfigsKey]).map((value, index) => {
      items.push({
        delete: <Button iconName="close" variant="icon" onClick={() => {
          deleteRow(filterIndex, index)
        }} />,
        column_name: <Select
        expandToViewport
          selectedOption={value.hasOwnProperty(props.columnNameKey) ? { 'label': value[props.columnNameKey], 'value': value[props.columnNameKey] } : null}
          onChange={({ detail }) =>
            onEditFilterConfig(filterIndex, detail.selectedOption.value, index, props.columnNameKey)
          }
          options={props.getColumns()}
          placeholder={props?.selectHint ? props.selectHint : "Choose options"}
        />,
        values: <SpaceBetween direction="vertical">
          <div className="param_input">
            <Box variant="h4">values</Box>
            <Input
              onChange={({ detail }) => {
                let val = detail.value
                onEditFilterConfig(filterIndex, { label: val.trim(), dismissLabel: val.trim() }, index, 'typed_value')

              }}
              onKeyDown={({ detail }) => {
                if (detail.key == 'Enter') {
                  if (value['typed_value'] == undefined || value['typed_value']?.label == undefined || value['typed_value']?.label == '') {

                  } else {
                    if (!value.hasOwnProperty('field_tokens')) {
                      value['field_tokens'] = []
                    }
                    value['field_tokens'].push(value['typed_value'])
                    // resetting the typed value for new values. Existing value is already added to token list
                    onEditFilterConfig(filterIndex, undefined, index, 'typed_value')
                  }
                }
              }}
              placeholder="values"
              value={value?.typed_value?.label}
              disabled={value?.field_type == 'input' ? true : (value.limit && value['field_tokens']?.length >= value.limit ? true : false)}
            />
            {
              value?.typed_value?.label ? <span className="hintMessage">Press Enter for the values to be considered</span> : ''
            }
          </div>
          <TokenGroup
            onDismiss={({ detail: { itemIndex } }) => {
              let arr = value?.field_tokens
              arr.splice(itemIndex, 1)
              onEditFilterConfig(filterIndex, arr, index, 'field_tokens')
            }}
            items={value?.field_tokens}
          />
        </SpaceBetween>,
        can_edit: <Checkbox
          onChange={({ detail }) =>
            onEditFilterConfig(filterIndex, detail.checked, index, props.radioKey)
          }
          checked={value.hasOwnProperty(props.radioKey) ? value[props.radioKey] : false}
          disabled={filter?.['extras']?.['allEdit'] || false}
        >
        </Checkbox>
      })
    })
    return items
  }

  const deleteRow = (filterIndex, index) => {
    filters[filterIndex]['information'].splice(index, 1)
    setFilters([...filters])
  }

  const saveConfiguration = () => {
    props.notify({ 'ACTION': 'SAVE' })
  }

  const addNewColumn = (filterIndex) => {
    addFilterColumn(filterIndex)
  }

  const addNewFilter = () => {
    addFilter()
  }

  const addFilterColumn = (filterIndex, colName = '', datatype = null) => {
    var newRow = {}
    newRow[props.columnNameKey] = colName
    newRow[props.radioKey] = props.radioKeyDefault
    newRow[props.lastUpdatedTimeKey] = null
    newRow['field_tokens'] = []
    let prevConfigs = filters?.[filterIndex]?.[props.filterConfigsKey] || []
    prevConfigs.push(newRow)
    filters[filterIndex][props.filterConfigsKey] = prevConfigs
    setFilters(JSON.parse(JSON.stringify(filters)))
  }

  const addFilter = (colName = '', datatype = null) => {
    var newRow = {}
    const newId = uuidv4()
    newRow['preferenceId'] = newId
    newRow[props.filterNameKey] = ''
    newRow[props.filterConfigsKey] = []
    setFilters([...filters, newRow])
  }

  const deleteFilter = (filterIndex) => {
    // check if this filter is used in the permission window
    props.checkIfFilterIsUsed(filters[filterIndex]['preferenceId'], function onResult(response) {
      if (!response.isFilterUsed) {
        filters[filterIndex]['to_delete'] = true
        setFilters(JSON.parse(JSON.stringify(filters)))
      } else {
        setErrorMessage(`Filter '${filters[filterIndex]['label']}' cannot be deleted since it is used in the permissions.`)
      }
    })

  }

  const undoDeleteFilter = (filterIndex) => {
    filters[filterIndex]['to_delete'] = false
    setFilters(JSON.parse(JSON.stringify(filters)))
  }

  const saveFilter = (filterIndex) => {
    props.notifyIndividual({ 'ACTION': 'SAVE' }, filterIndex)
  }

  const getFilterActionButtons = (filterIndex) => {
    return <SpaceBetween direction="horizontal" size="l" index={filterIndex}>
        {
          filters?.[filterIndex]?.['to_delete'] ? <Button onClick={() => undoDeleteFilter(filterIndex)}>Undo delete filter</Button> :
            <>
              <Button variant="primary" onClick={() => saveFilter(filterIndex)}>Save filter</Button>
              <Button onClick={() => deleteFilter(filterIndex)}>Delete filter</Button>
            </>
        }
      <Button onClick={() => addNewColumn(filterIndex)}>Add column</Button>
    </SpaceBetween>
  }

  const getActionButtons = () => {
    return <SpaceBetween direction="vertical" size="s">
      <SpaceBetween direction="horizontal" size="s">
        {
          props?.loadingMessage ? <SpaceBetween direction="horizontal" size="m">
            <Spinner></Spinner>
            <Box color={props.loadingMessage?.type == 'success' ? 'text-status-inactive' : 'text-status-error'}>{props.loadingMessage?.message}</Box>
          </SpaceBetween> : <></>
        }
        <Button onClick={addNewFilter}>Add Filter</Button>
        <Button variant="primary" onClick={saveConfiguration} disabled={props.tancId == null}>Save</Button>
      </SpaceBetween>
    </SpaceBetween>
  }

  const loadRows = () => {
    let values = props.getValues()
    if (values == null) {
      return
    }
    setFilters(JSON.parse(JSON.stringify(values)))
  }

  return (
    <SpaceBetween size="m">
      {
        props?.loadingMessage ? <SpaceBetween direction="horizontal" size="m">
          <Spinner></Spinner>
          <Box color={props.loadingMessage?.type == 'success' ? 'text-status-inactive' : 'text-status-error'}>{props.loadingMessage?.message}</Box>
        </SpaceBetween> : <></>
      }
      {props.info && props.info != ' ' && props.info != '' ? <><span className="info">{props.info}</span> <br></br> </> : ''}
      {errorMessage && errorMessage != '' ? <><span className="error"> {errorMessage} </span><br></br></> : ''}
        {filters ? (Array.from(filters).map((value, index) => {
          return getFilterItem(value, index);
        })) : ''}
      <Box float="right">
        {
          getActionButtons()
        }
      </Box>
    </SpaceBetween>
  )
}

export default TANCFilterManager;